<template>
  <button
      v-if="hasQuery"
      class="autocomplete-search__clear-query-button q-position-absolute q-btn-close q-bg-light q-p-2 " type="button"
      :class="{ 'q-input-with-button': showButtonOnInput }"
      title="Wyczyść"
      aria-label="Clear"
      @click.prevent="urlStore.clearQuery(redirectionUrl, autocomplete)">
  </button>
</template>
<script setup lang="ts">

import {useUrlStore} from "@/store/SerpPage/UrlStore";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {inject, ref, toRefs, defineProps} from "vue";
import {SmartSearchConfigInterface} from "@/core/types";
defineProps(['autocomplete'])
const urlStore = useUrlStore()
const queryStore = useSearchQueryStore();
const {hasQuery} = toRefs(queryStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!)
const {showButtonOnInput} = SmartSearchConfig.value.serp
const {redirectionUrl} = SmartSearchConfig.value.appConfiguration

</script>
<style>
.autocomplete-search__clear-query-button {
  padding: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  right: 20px;
  top: 50%;
  transform: translate(0px, -50%);
  z-index: 10 !important;
}

.autocomplete-search__clear-query-button.q-input-with-button {
  right: 100px;
}
</style>
